import { Popover as AntPopover } from "antd";

const Popover = ({ title, content, children }) => {
  const titleStyled = (
    <div
      style={{
        fontWeight: "500",
        color: "black",
      }}
    >
      {title}
    </div>
  );

  const contentStyled = (
    <div
      style={{
        fontWeight: "500",
        color: "grey",
        // borderRadius: 8,
        // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        // padding: 12,
        backgroundColor: "#fff",
      }}
    >
      {content}
    </div>
  );

  return (
    <AntPopover
      title={titleStyled}
      content={contentStyled}
      trigger={["hover", "click"]}
    >
      {children}
    </AntPopover>
  );
};

export default Popover;
